export default "__VITE_ASSET__CyLIqd19__"